import {InternationalShipment, type InternationalShipmentData} from "@/types/shipments/International/InternationalShipment.ts";

export class InternationalRoadShipmentTrackingUrl {
    public id:number|null;
    public international_shipment_id:number;
    public guid:string;
    public shipment: InternationalShipment | null;

    constructor(data:InternationalRoadShipmentTrackingUrlData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.international_shipment_id = 0;
            this.guid = "";
            this.shipment = null;
        }
        else
        {
            this.id = data.id;
            this.international_shipment_id = data.international_shipment_id;
            this.guid = data.guid;
            this.shipment = null;
            if (data.shipment !== undefined && data.shipment !== null) {
                this.shipment = new InternationalShipment(data.shipment)
            }
        }
    }
}

export type InternationalRoadShipmentTrackingUrlData = {
    id:number|null;
    international_shipment_id:number;
    guid:string;
    shipment: InternationalShipmentData | null;
}